<script lang="ts">
    import { Col, ListGroup, ListGroupItem } from "sveltestrap";
    import {  Contextualclasses, Dapibusacfacilisisin, Thisisaprimary } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    import data from "../../../Data/ComponentData/Ui-kits/Lists/Lists.json"
</script>
<Col sm="12" xl="12">
    <Card cardHeaderprops="pb-0" headerTitle={Contextualclasses}>
      <div slot="contentbody">
        <ListGroup>
            <ListGroupItem>{Dapibusacfacilisisin}</ListGroupItem>
            <ListGroupItem color="primary">{Thisisaprimary}</ListGroupItem>
            {#each data.Contextualclassesdata as listItem }
              <ListGroupItem color={listItem.color}>{listItem.title}</ListGroupItem>
            {/each}
        </ListGroup>
      </div>
    </Card>
</Col>